module.exports = __webpack_public_path__ + "img/icon-export-fundings.143fb09a.svg";